import React, { useMemo } from "react";
import OverlayLoader from "../../Common/OverlayLoader";

const TasksCard = ({ highPriorityCount, mediumPriorityCount, routinePriorityCount, isLoading }) => {
  const containerStyles = {
    position: "relative",
    height: "100%",
  };

  const listStyles = {
    width: "100%",
    fontSize: "14px",
  };

  const sum = useMemo(() => {
    return highPriorityCount + mediumPriorityCount + routinePriorityCount;
  }, [highPriorityCount, mediumPriorityCount, routinePriorityCount]);

  return (
    <div className="dashboard-box">
      <h6 className="sidebar-heading d-flex justify-content-between align-items-center ">
        <strong>
          <span>Tasks</span>
        </strong>
      </h6>
      <div style={containerStyles}>
        <div className="list-group list-group-flush" style={listStyles}>
          <a
            onClick={(e) => {}}
            className="list-group-item sidebar-item d-flex align-items-center label-cont"
            href="#!"
          >
            <i className="fas fa-fw mr-2 fa-angle-double-up fa-md" style={{ color: "#04589e" }}></i>
            <span className="text-truncate text-">High Priority</span>
            <span className="badge ml-auto">{highPriorityCount}</span>
          </a>
          <a
            onClick={(e) => {}}
            className="list-group-item sidebar-item d-flex align-items-center label-cont"
            href="#!"
          >
            <span
              style={{
                padding: "0px 4px",
                marginRight: "5px",
                fontWeight: "bold",
                color: "#f6c23e",
              }}
            >
              =
            </span>
            <span className="text-truncate text-">Medium Priority</span>
            <span className="badge ml-auto">{mediumPriorityCount}</span>
          </a>
          <a
            onClick={(e) => {}}
            className="list-group-item sidebar-item d-flex align-items-center label-cont"
            href="#!"
          >
            <i className="fas fa-fw mr-2 fa-angle-double-down fa-md hc-primary-text"></i>
            <span className="text-truncate text-">Low Priority</span>
            <span className="badge ml-auto">{routinePriorityCount}</span>
          </a>
        </div>
      </div>
      {isLoading && <OverlayLoader isLoading={sum === 0} />}
    </div>
  );
};

export default TasksCard;
